import Component from "./Search";
import * as sources from "./components";

export interface ISearchExtensions {
    Bottom: typeof sources.Bottom;
    LeftAddon: typeof sources.LeftAddon;
    Right: typeof sources.Right;
    Menu: typeof sources.Menu;
    MenuItem: typeof sources.MenuItem;
    Dropdown: typeof sources.Dropdown;
    NotFoundStub: typeof sources.NotFoundStub;
}

export const Search: typeof Component & ISearchExtensions = Object.assign(
    Component,
    sources,
);
